// src/App.js
import React, { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import routes from './routes/index';
import NavigationBar from './components/TopNav/TopNav';
import BottomNav from './components/BottomNav/BottomNav';
import { useAuth } from './modules/Base/Auth/contexts/AuthContext';
import Loader from './components/Loader/Loader';
import { useGeo } from './context/GeoContext';
import { useGeolocationSubscription } from './hooks/useGeolocationSubscription';
import './styles/global.css';

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  const routing = useRoutes(routes);
  const { geoEnabled, setGeoEnabled } = useGeo();
  const [toast, setToast] = useState(null);

  useGeolocationSubscription(
    geoEnabled,
    null,
    null,
    (mode, enabled, reason) => {
      setGeoEnabled(enabled);
      setToast(
        reason
          ? `Геолокация (${mode}) отключена: ${reason}`
          : `Геолокация (${mode}) выключена`
      );
    }
  );

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(null), 1000);
    return () => clearTimeout(id);
  }, [toast]);

  if (loading) return <Loader />;
      //{toast && <div className="geo-toast">{toast}</div>}

  return (
    <>
      {isAuthenticated && <NavigationBar />}
      {isAuthenticated && <BottomNav />}
      {routing}
    </>
  );
}

export default function App() {
  return <AppContent />;
}
